import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-70px" }}
        transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const SectionHead = ({ eyebrow, title, sub, testid }) => (
    <div className="max-w-3xl" data-testid={testid}>
        <Reveal>
            <p className="ff-mono text-xs uppercase tracking-[0.25em] text-cyan-400 mb-4">{eyebrow}</p>
        </Reveal>
        <Reveal delay={0.08}>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white leading-[1.1]">{title}</h2>
        </Reveal>
        {sub && (
            <Reveal delay={0.16}>
                <p className="mt-5 text-base sm:text-lg text-slate-400 leading-relaxed">{sub}</p>
            </Reveal>
        )}
    </div>
);
